import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RequiresPermissionsModule } from '../directives';
import { EtaModule } from '../eta/eta.module';
import { InlineEditComponentModule } from '../inline-edit/inline-edit.module';
import { TripOverviewDetailComponent } from './trip-overview-detail.component';
import { UzurvPipesModule } from '@uzurv/core';
import { RiderMobilityProfileDetailComponent } from '../rider-mobility-profile-detail/rider-mobility-profile-detail.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [TripOverviewDetailComponent],
  imports: [
    CommonModule,
    FormsModule,
    InlineEditComponentModule,
    EtaModule,
    RequiresPermissionsModule,
    UzurvPipesModule,
    RiderMobilityProfileDetailComponent,
    MatIconModule
  ],
  exports: [TripOverviewDetailComponent]
})
export class TripOverviewDetailModule {}
